import { render, staticRenderFns } from "./XcalacocoBookings.vue?vue&type=template&id=71b01863&"
import script from "./XcalacocoBookings.vue?vue&type=script&lang=js&"
export * from "./XcalacocoBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports